import Item1 from "../../images/gtav.jpg"
import Item2 from "../../images/acv.jpg"
import Item3 from "../../images/bak.jpg"
import Item4 from "../../images/fc6.jpg"
import Item5 from "../../images/valo2.jpg"
import Item6 from "../../images/scb.jpg"
import Item7 from "../../images/amongus.jpg"
import Item8 from "../../images/blur.jpg"
import Item9 from "../../images/fortnite.jpg"
import Item10 from "../../images/nfs.jpg"
import Item11 from "../../images/lofus.jpg"
import { ADD_TO_CART , REMOVE_ITEM , ADD_QUANTITY , SUB_QUANTITY , ADD_SHIPPING} from '../Actions/Action-types';


const initState = {
 items: [
    {id:1,title:'GTA V', desc: "The 5th insatllment of the popular franchise", price:10,img:Item1},
    {id:2,title:'Assassians Creed:Valhalla', desc: "The popular action franchise returns!", price:25,img:Item2},
    {id:3,title:'Batman:Arkham Knight', desc: "Be the Batman!The caped crusader...", price:20,img:Item3},
    
    {id:4,title:'Far Cry:6', desc:"Witness the epic story of a nation's rebellion!", price:25,img:Item4},
    {id:5,title:'Valorant', desc: "Fast paced 4v4 online multiplayer", price:5,img:Item5},
    {id:6,title:'Splinter Cell:Blacklist', desc:"The best spy-action game franchise!", price:15,img:Item6},
    {id:7,title:'Among Us', desc:"Have trust issues?Play this game;)", price:10,img:Item7},
    {id:8,title:'Blur', desc:"Racing has no rules!", price:12,img:Item8},
    {id:9,title:'Fortnite', desc:"The original battle royale experience!", price:5,img:Item9},
    {id:10,title:'Need For Speed:Payback', desc:" The Road rash of Gen-Z", price:8,img:Item10},
    {id:11,title:'The Last of Us 2', desc:"Survive the zombie apocalpse in the latest installment!", price:25,img:Item11}
    
    
    
 ] , 
 addedItems:[],
 total: 0
}
const cartReducer= (state = initState,action)=>{
    if(action.type === ADD_TO_CART){
        let addedItem = state.items.find(item=> item.id === action.id)
        //check if the action id exists in the addedItems
       let existed_item= state.addedItems.find(item=> action.id === item.id)
       if(existed_item)
       {
          addedItem.quantity += 1 
           return{
              ...state,
               total: state.total + addedItem.price 
                }
      }
       else{
          addedItem.quantity = 1;
          //calculating the total
          let newTotal = state.total + addedItem.price 
          
          return{
              ...state,
              addedItems: [...state.addedItems, addedItem],
              total : newTotal
          }
          
      }
  }
  if(action.type === REMOVE_ITEM){
    let itemToRemove= state.addedItems.find(item=> action.id === item.id)
    let new_items = state.addedItems.filter(item=> action.id !== item.id)
    
    //calculating the total
    let newTotal = state.total - (itemToRemove.price * itemToRemove.quantity )
    console.log(itemToRemove)
    return{
        ...state,
        addedItems: new_items,
        total: newTotal
    }
}
//Inside Cart item card buttons:
if(action.type=== ADD_QUANTITY){
    let addedItem = state.items.find(item=> item.id === action.id)
      addedItem.quantity += 1 
      let newTotal = state.total + addedItem.price
      return{
          ...state,
          total: newTotal
      }
}
if(action.type=== SUB_QUANTITY){  
    let addedItem = state.items.find(item=> item.id === action.id) 
    //if the qt == 0 then it should be removed
    if(addedItem.quantity === 1){
        let new_items = state.addedItems.filter(item=>item.id !== action.id)
        let newTotal = state.total - addedItem.price
        return{
            ...state,
            addedItems: new_items,
            total: newTotal
        }
    }
    else {
        addedItem.quantity -= 1
        let newTotal = state.total - addedItem.price
        return{
            ...state,
            total: newTotal
        }
    }
    
}
if(action.type=== ADD_SHIPPING){
    return{
        ...state,
        total: state.total + 6
    }
}

if(action.type=== 'SUB_SHIPPING'){
  return{
      ...state,
      total: state.total - 6
  }
}

else{
return state
}
}


   


export default cartReducer;